// Authentication URLs
export const LOGIN = "api/users/login";
export const PASSWORD_FORGET = "api/users/forgot-password";
export const RESET_PASSWORD = "api/users/reset-password";
export const EDIT_USER = "/api/users/update";
export const FETCH_PROFILE = "/api/users/me";

// Dashboard
export const DASHBOARD_COUNT_URL = "/api/admin/analytics";

// Users
export const GET_ALL_USERS = "/api/admin/users";
export const BULK_DELETE_USERS = "/api/users/bulk-delete";

// News
export const GET_ALL_NEWS = "/api/news";
export const BULK_DELETE_NEWS = "/api/news/bulk-delete";

// Posts
export const GET_ALL_POSTS = "/api/post";
export const BULK_DELETE_POSTS = "/api/post/bulk-delete";

//Chats
export const CHAT_REQUESTS = "/api/chat/requests";
export const CHAT_BY_ID = "/api/chat"; 
export const CREATE_GROUP_CHAT = "/api/chat/group";
export const EDIT_CHAT_MESSAGE = "/api/chat"; 
export const DELETE_CHAT_MESSAGE = "/api/chat/messages";

// Policy & Terms
export const POLICY_BASE = "/api/policy"; 
export const TERMS_BASE = "/api/terms";

//Contact Us
export const GET_ALL_CONTACTS = "/api/contact/all";
export const GET_CONTACT_BY_ID = "/api/contact";

// Subscriptions
export const GET_ALL_SUBSCRIPTIONS = "/api/subscription/admin/list";
export const GET_SUBSCRIPTION_BY_ID = "/api/subscription/admin";

//notifications
export const NOTFICATIONS = "/api/notification"

// Drawings History
export const GET_DRAWINGS_HISTORY = "/api/drawings/history";